import StatsBar from "./StatsBar"
import LocationCard from "./LocationCard"
import { useState, useEffect, useMemo } from "react"
import styled from "styled-components"
import { useResto } from "../hooks/useResto"
import { IconChapa, IconRanking } from "./Icons"
import { useUser } from "../hooks/useUser"
import { useOwnerRestaurantSelection } from "../hooks/useOwnerRestaurantSelection"
import QRCodeDisplay from "./QRCodeDisplay"
import { qrBaseUrl } from "../Endpoint"

export const RightBar = ({
    restoName = "",
    restoAddress = "",
    restoId = null,
    restos = [],
    showEvaluationQr = false,
}) => {
    const { isOwner, userId } = useUser()
    const { getPosition, restoPosition, getLikesCount, getCountryResto, getNotifyCount, restoCountry, restoLikes } = useResto()
    const {
        ownerRestaurants,
        selectedOwnerRestaurantId,
        setSelectedOwnerRestaurantId,
        selectedOwnerRestaurant,
    } = useOwnerRestaurantSelection()
    const [position, setPosition] = useState(0);
    const [positionTotal, setPositionTotal] = useState(0);
    const [country, setCountry] = useState("");
    const [likes, setLikes] = useState(0);
    const [loader2, setloader2] = useState(restoPosition ? false : true);
    const [loader4, setloader4] = useState(restoLikes ? false : true);
    const [loader5, setloader5] = useState(restoCountry ? false : true);

    // LLAMAR AL BACK PARA TRAER LA PROMO ACTUAL -> restoId

    useEffect(() => {
        let isMounted = true;
        
        const fetchData = async () => {
            try {
                // Ejecutar peticiones con delay escalonado para evitar rate limiting
                // En lugar de Promise.all, ejecutar secuencialmente con pequeños delays
                await getPosition();
                await new Promise(resolve => setTimeout(resolve, 200));
                
                if (!isMounted) return;
                await getLikesCount();
                await new Promise(resolve => setTimeout(resolve, 200));
                
                if (!isMounted) return;
                await getCountryResto();
                await new Promise(resolve => setTimeout(resolve, 200));
                
                if (!isMounted) return;
                await getNotifyCount();
            } catch (error) {
                if (isMounted) {
                    console.error('Error fetching resto data:', error);
                }
            }
        };
        
        fetchData();
        
        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOwnerRestaurantId]) // En owner, refrescar stats al cambiar el almacén seleccionado

    useEffect(() => {
        let isMounted = true;
        
        if (isMounted && restoPosition && typeof restoPosition === 'object' && !Array.isArray(restoPosition)) {
            const pos = typeof restoPosition.position === 'number' ? restoPosition.position : 0;
            const total = typeof restoPosition.total === 'number' ? restoPosition.total : 0;
            setPosition(pos);
            setPositionTotal(total);
            setloader2(false);
        }
        
        return () => {
            isMounted = false;
        };
    }, [restoPosition])

    useEffect(() => {
        let isMounted = true;
        
        if (isMounted && restoLikes !== null && restoLikes !== undefined) {
            const likes = typeof restoLikes === 'number'
                ? restoLikes
                : (typeof restoLikes === 'object' ? 0 : Number(restoLikes) || 0);
            setLikes(likes);
            setloader4(false);
        }
        
        return () => {
            isMounted = false;
        };
    }, [restoLikes])

    useEffect(() => {
        let isMounted = true;
        
        if (isMounted && restoCountry && typeof restoCountry === 'object' && !Array.isArray(restoCountry)) {
            const countryValue = typeof restoCountry.country === 'string' ? restoCountry.country : '';
            if (countryValue) {
                setCountry(countryValue);
                setloader5(false);
            }
        }
        
        return () => {
            isMounted = false;
        };
    }, [restoCountry])

    const stats = [
        /* { icon: <IconRanking width="20" height="20" />, value: position, sub: positionTotal, loader: loader2 }, */
        { icon: <IconChapa width="24" height="24" />, value: likes, loader: loader4 },
    ]

    // Temporalmente oculto: acceso rápido a packs de tópicos.
    // const openTopicPacks = () => {
    //     const query = new URLSearchParams(location.search)
    //     query.set("tab", "quizzes")
    //     query.set("quizTab", "packs")
    //     history.push({ pathname: location.pathname, search: query.toString() })
    // }

    const activeOwnerRestaurants = Array.isArray(ownerRestaurants)
      ? ownerRestaurants.filter((item) => item?.active !== false)
      : []
    const activeRestos = Array.isArray(restos)
      ? restos.filter((item) => item?.active !== false)
      : []

    const locationItems = activeRestos.length
      ? activeRestos
      : activeOwnerRestaurants.length
        ? activeOwnerRestaurants
        : [{ id: restoId || "resto-default", name: restoName, address: restoAddress }]
    const selectedLocation = isOwner
      ? (
          activeOwnerRestaurants.find(
            (item) => String(item?._id || item?.id || item?.restoId || "") === String(selectedOwnerRestaurantId)
          ) ||
          locationItems[0] ||
          null
        )
      : (locationItems[0] || null)
    const selectedWarehouseId = useMemo(() => String(
      userId ||
      selectedOwnerRestaurantId ||
      selectedOwnerRestaurant?._id ||
      selectedOwnerRestaurant?.id ||
      selectedOwnerRestaurant?.place_id ||
      selectedOwnerRestaurant?.restoId ||
      restoId ||
      ""
    ), [restoId, selectedOwnerRestaurant, selectedOwnerRestaurantId, userId])
    const evaluationUrl = isOwner && showEvaluationQr && selectedWarehouseId
      ? `${qrBaseUrl}/w/${selectedWarehouseId}`
      : ""

    return <>
        <RightBarPanel>
            <StatsBar
                country={country}
                loaderCountry={loader5}
                stats={stats}
            />

            {isOwner && activeOwnerRestaurants.length > 1 && (
              <OwnerSelectGroup>
                <OwnerSelectLabel htmlFor="owner-resto-select">
                  Almacén activo
                </OwnerSelectLabel>
                <OwnerSelect
                  id="owner-resto-select"
                  value={selectedOwnerRestaurantId}
                  onChange={(e) => setSelectedOwnerRestaurantId(e.target.value)}
                >
                  {activeOwnerRestaurants.map((item) => (
                    <option
                      key={String(item?._id || item?.id || item?.restoId || item?.name)}
                      value={String(item?._id || item?.id || item?.restoId || "")}
                    >
                      {item?.name || "Almacén"}
                    </option>
                  ))}
                </OwnerSelect>
              </OwnerSelectGroup>
            )}

            {selectedLocation && (
              <LocationCard
                key={selectedLocation?.id || selectedLocation?._id || "resto-selected"}
                name={selectedLocation?.name || restoName}
                address={selectedLocation?.address || restoAddress}
              />
            )}

            {evaluationUrl && (
              <QrPanel>
                <QrTitle>
                  QR de evaluación
                </QrTitle>
                <QRCodeDisplay
                  text={evaluationUrl}
                  userName={selectedLocation?.name || restoName || "almacen"}
                  displaySize={240}
                  sizeCm={3}
                  showUpdateButton={false}
                />
              </QrPanel>
            )}
        </RightBarPanel>
    </>
}

const RightBarPanel = styled.div`
  padding: 20px;
`;

const OwnerSelectGroup = styled.div`
  margin-bottom: 8px;
`;

const OwnerSelectLabel = styled.label`
  display: block;
  margin-bottom: 6px;
  color: #6b7280;
  font-size: 12px;
`;

const OwnerSelect = styled.select`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #ffffff;
`;

const QrPanel = styled.div`
  display: grid;
  gap: 10px;
  justify-items: center;
  margin-top: 14px;
  padding: 14px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
`;

const QrTitle = styled.div`
  color: #111827;
  font-size: 13px;
  font-weight: 700;
`;
